import * as React from 'react';
import { Alert, Stack, Button } from '@mui/material';
import PropTypes from 'prop-types';

export const AlertSeverityTypes = {
  error: 'error',
  success: 'success',
  info: 'info',
  warning: 'warning',
};

export const FlexAlerts = (props) => {
  const { messages } = props;
  return (
    <Stack sx={{ width: '100%' }} spacing={2}>
      {messages.map((item, index) => {
        return (
          <Alert
            data-cy={item.severity + 'Alert'}
            key={index}
            severity={item.severity}
            action={
              item.action && (
                <Button color="inherit" size="small" onClick={item.action?.onClick}>
                  {item.action?.text}
                </Button>
              )
            }
          >
            {item.message}
          </Alert>
        );
      })}
    </Stack>
  );
};

FlexAlerts.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      severity: PropTypes.string.isRequired,
      message: PropTypes.string,
      action: PropTypes.shape({
        text: PropTypes.string,
        onClick: PropTypes.func,
      }),
    })
  ),
};
